(function () {
  function getScrollAmount(track) {
    var card = track.querySelector('.bestsellers__card');
    var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
    if (!card) return track.clientWidth || 316;
    return card.getBoundingClientRect().width + gap;
  }

  function updateArrowState(carousel) {
    var track = carousel.querySelector('[data-bestsellers-track]');
    if (!track) return;

    var panel = carousel.closest('.bestsellers__panel');
    if (panel && panel.hidden) return;

    var nav = carousel.querySelector('.bestsellers__nav');
    if (!nav || nav.offsetParent === null) return;

    var prevBtn = nav.querySelector('[data-bestsellers-prev]');
    var nextBtn = nav.querySelector('[data-bestsellers-next]');
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var tolerance = 2;

    if (prevBtn) prevBtn.disabled = maxScroll <= tolerance || track.scrollLeft <= tolerance;
    if (nextBtn) nextBtn.disabled = maxScroll <= tolerance || track.scrollLeft >= maxScroll - tolerance;
  }

  function bindCarousel(carousel) {
    if (carousel.dataset.bsBound === 'true') return;
    carousel.dataset.bsBound = 'true';

    var track = carousel.querySelector('[data-bestsellers-track]');
    if (!track) return;

    var prevBtn = carousel.querySelector('[data-bestsellers-prev]');
    var nextBtn = carousel.querySelector('[data-bestsellers-next]');

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(track), behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(track), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      updateArrowState(carousel);
    });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        updateArrowState(carousel);
      }).observe(track);
    }

    track.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        updateArrowState(carousel);
      });
    });

    scheduleRefresh(carousel);
  }

  function refreshSection(section) {
    section.querySelectorAll('[data-bestsellers-carousel]').forEach(function (carousel) {
      updateArrowState(carousel);
    });
  }

  /* The first paint can report a zero-width track, so re-measure once the frame
     has been laid out and again once fonts and images have settled. */
  function scheduleRefresh(node) {
    var run = function () {
      if (node.matches('[data-bestsellers-carousel]')) updateArrowState(node);
      else refreshSection(node);
    };

    requestAnimationFrame(function () {
      requestAnimationFrame(run);
    });

    if (document.readyState !== 'complete') {
      window.addEventListener('load', run, { once: true });
    }
  }

  function activateTab(section, tabs, panels, tab) {
    var index = tab.getAttribute('data-tab-index');

    tabs.forEach(function (candidate) {
      var isActive = candidate === tab;
      candidate.classList.toggle('is-active', isActive);
      candidate.setAttribute('aria-selected', isActive ? 'true' : 'false');
      candidate.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-panel-index') === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;

      if (isActive) {
        var track = panel.querySelector('[data-bestsellers-track]');
        if (track) track.scrollLeft = 0;
      }
    });

    requestAnimationFrame(function () {
      refreshSection(section);
    });
  }

  function initSection(section) {
    section.querySelectorAll('[data-bestsellers-carousel]').forEach(bindCarousel);

    if (section.dataset.bsBound === 'true') {
      scheduleRefresh(section);
      return;
    }
    section.dataset.bsBound = 'true';

    var tabs = Array.prototype.slice.call(section.querySelectorAll('.bestsellers__tab'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('.bestsellers__panel'));

    tabs.forEach(function (tab, position) {
      tab.addEventListener('click', function () {
        activateTab(section, tabs, panels, tab);
      });

      // Roving tabindex: arrow keys move between tabs, as expected of a tablist.
      tab.addEventListener('keydown', function (event) {
        var offset = 0;
        if (event.key === 'ArrowRight') offset = 1;
        else if (event.key === 'ArrowLeft') offset = -1;
        else if (event.key === 'Home') offset = -position;
        else if (event.key === 'End') offset = tabs.length - 1 - position;
        else return;

        event.preventDefault();
        var next = tabs[(position + offset + tabs.length) % tabs.length];
        if (!next) return;
        next.focus();
        activateTab(section, tabs, panels, next);
      });
    });

    scheduleRefresh(section);
  }

  function initAll() {
    document.querySelectorAll('.bestsellers').forEach(initSection);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.bestsellers').forEach(refreshSection);
    }, 150);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bestsellers');
    if (section) initSection(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
